import { render, staticRenderFns } from "./PublishClaim.vue?vue&type=template&id=440f1ded&scoped=true"
import script from "./PublishClaim.vue?vue&type=script&lang=js"
export * from "./PublishClaim.vue?vue&type=script&lang=js"
import style0 from "./PublishClaim.vue?vue&type=style&index=0&id=440f1ded&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440f1ded",
  null
  
)

export default component.exports